module.exports = __webpack_public_path__ + "media/images/icons/search-table-880e2eb70e5c525293e9a4b1bebfafe6.svg";